import * as React from 'react';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';
import {Diamonds} from './Diamonds';
import Radium, { StyleRoot } from 'radium';
import * as Tgcc from '../tgccGlobal';



const ulStyle:React.CSSProperties = {
    listStyleType:'none',
    display:'inline-block',
    width:'160px',
    color:'#616060',
    cursor:'pointer',
    paddingLeft:'0px',
    position:'relative',

}
var socialMediaUl = Object.assign({},ulStyle,{});
var ulStyle1 = Object.assign({},ulStyle,{});
const licenseUL: React.CSSProperties = {
    listStyleType:'none',
    display:'inline-block',
    width:'160px',
    color:'#616060',
    cursor:'pointer',
    paddingLeft:'0px',
    position:'relative',
}

const socialLink: React.CSSProperties = {
    textDecoration:'none'
}

const bottomListStyle: React.CSSProperties = {
    textAlign:'center',
    fontFamily:'BarlowLight',
    width:'90%'
}

const footerStyles: React.CSSProperties = {
    backgroundColor:'white',
    textAlign:'center',
    lineHeight:'4.2em',
    width:'100%',
    height:'61px',
    fontFamily:'Lulo',
    color:'#616060'
}
const containerDiv: React.CSSProperties = {
    width:'100%',
    marginTop:'75px'
}

const licenseStyle: React.CSSProperties = {
    width:'313px',
    height:'150px'
}
const groupImg: React.CSSProperties = {
    width:'313px'
}
const groupUL: React.CSSProperties = {
    listStyleType:'none',
    display:'inline-block',
    color:'#616060',
    cursor:'pointer',
    paddingLeft:'0px',
}
const footerLi: React.CSSProperties = {
    marginBottom:'15px'
}

const liTurnAround: React.CSSProperties = {
    position:'relative',
    top:'19px'
}

const socialMediaIcons: React.CSSProperties = {
    width:'25px'
}
const socialMediaLi: React.CSSProperties = {
    display:'inline-block',
    marginRight:'5px'
}


class _MajorAccountsFooter extends React.Component <Tgcc.BaseProps,any > {

    openContact = () =>{browserHistory.push(Tgcc.Routes.Contact)};
    openAbout = () =>{browserHistory.push(Tgcc.Routes.About)};
    openShipping = () => {browserHistory.push(Tgcc.Routes.MajorAccountShipping)};
    openFAQ = () => {browserHistory.push(Tgcc.Routes.MajorAccountsFAQ)};


    getBottomSection(){
        return (
            <div style={bottomListStyle} className="corpFooterCont">
            <ul style={groupUL} className="corpFooterLic">
                    <li><img style={groupImg} src={Tgcc.ResolveUrl('~/images/Footer-01-01.png')} /></li>
                </ul>
                <ul style={ulStyle1} className="corpFooterUl">
                    <li style={footerLi}><i><div onClick={this.openAbout}>About Us</div></i></li>
                    <li style={footerLi}><i><div onClick={this.openContact}>Contact</div></i></li>
                </ul>
                <ul style={socialMediaUl} className="socialMediaUl">
                    <li style={socialMediaLi}><a style={socialLink} href="https://www.facebook.com/thegraphiccow"><img style={socialMediaIcons} src={Tgcc.ResolveUrl('~/images/Facebook.png')} /></a></li>
                    <li style={socialMediaLi}><a href="https://www.instagram.com/thegraphiccow/"><img style={socialMediaIcons} src={Tgcc.ResolveUrl('~/images/Instagram.png')} /></a></li>
                    <li style={socialMediaLi}><a href="https://www.pinterest.com/grafcowcompany/"><img style={socialMediaIcons} src={Tgcc.ResolveUrl('~/images/Pinterest.png')} /></a></li>
                </ul>
                <ul style={ulStyle} className="corpFooterUl">
                    <li><div onClick={this.openFAQ}><i>FAQS</i></div></li>
                    <li style={liTurnAround}><div onClick={this.openShipping}><i>Turn Around &#38; Returns</i></div></li>
                </ul>
                
            </div>
        )
    }
    getFooter() {
        const currentYear = new Date().getFullYear();
        return (
            <div style={footerStyles}>
                {`${currentYear} BY THE GRAPHIC COW COMPANY`}
            </div>
        );
    }
    

    render() {
            return (
            <div style={containerDiv} className="corpBottomDiv">
                {this.getBottomSection()}
                {this.getFooter()}
            </div>
        ) 
    }
}


const mapStateToProps = (state: Tgcc.GlobalState, ownProps: Tgcc.BaseProps) => {
    return { state: state};
};
export var MajorAccountsFooter = connect(mapStateToProps)(Radium(_MajorAccountsFooter));

